import React from 'react';
import { TextButton } from 'seagull';
import styles from "./TimeActivityActions.module.scss";
export const TimeActivityActions = _ref => {
  let {
    refresh
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.actions
  }, /*#__PURE__*/React.createElement(TextButton, {
    weight: "normal",
    underline: "none"
  }, "Add all"), /*#__PURE__*/React.createElement(TextButton, {
    onClick: refresh,
    weight: "normal",
    underline: "none",
    "data-testid": "refresh-time-activities"
  }, "Refresh"));
};